import React, { useState } from "react";
import { parseContent } from "../utils/parser";
import "../styles/ContentInput.css";

const ContentInput = ({ onParse }) => {
  const [rawContent, setRawContent] = useState("");
  const [parseCount, setParseCount] = useState(0);

  const handlePaste = (e) => {
    const pastedText = e.clipboardData.getData("text");
    setRawContent(pastedText);
  };

  const handleChange = (e) => {
    setRawContent(e.target.value);
  };

  const handleParse = () => {
    if (!rawContent.trim()) {
      alert("Please paste or enter content first");
      return;
    }

    const sections = parseContent(rawContent);
    setParseCount(sections.length);
    onParse(sections);
  };

  const handleClear = () => {
    if (rawContent && !window.confirm("Clear all content?")) return;
    setRawContent("");
    setParseCount(0);
  };

  const charCount = rawContent.length;
  const lineCount = rawContent.split("\n").length;

  return (
    <div className="content-input-container">
      <div className="input-header">
        <h2>📝 Paste Your Content</h2>
        <p className="subtitle">
          Paste raw text (blog, article, whitepaper) and we'll automatically parse it into sections
        </p>
      </div>

      <div className="stats">
        <div className="stat">
          <span className="stat-label">Characters:</span>
          <span className="stat-value">{charCount.toLocaleString()}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Lines:</span>
          <span className="stat-value">{lineCount}</span>
        </div>
        {parseCount > 0 && (
          <div className="stat">
            <span className="stat-label">Sections:</span>
            <span className="stat-value success">{parseCount}</span>
          </div>
        )}
      </div>

      <textarea
        className="content-textarea"
        value={rawContent}
        onChange={handleChange}
        onPaste={handlePaste}
        placeholder="Paste your content here...&#10;&#10;Supports:&#10;• Markdown headers (# Heading, ## Subheading)&#10;• Lists (- Item 1, - Item 2)&#10;• Tables (with pipes |)&#10;• YouTube links&#10;• And regular paragraphs"
      />

      <div className="input-actions">
        <button className="btn-primary" onClick={handleParse}>
          🔍 Parse Content
        </button>
        <button className="btn-secondary" onClick={handleClear}>
          ✕ Clear
        </button>
      </div>

      <div className="tips">
        <h3>💡 Parsing Tips</h3>
        <ul>
          <li><strong>Headings:</strong> Use # (h1), ## (h2), ### (h3)</li>
          <li><strong>Lists:</strong> Use - or * at the start of a line</li>
          <li><strong>Paragraphs:</strong> Regular text or multiple lines</li>
          <li><strong>Tables:</strong> Pipe-delimited (|) will be detected</li>
          <li><strong>YouTube:</strong> Full YouTube URLs are automatically detected</li>
          <li><strong>Sections:</strong> Empty lines break sections into new items</li>
        </ul>
      </div>
    </div>
  );
};

export default ContentInput;
